import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { App } from './App';
import 'font-awesome/css/font-awesome.min.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { store } from './helpers';

render(
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <Provider store={store}>
      <App />
    </Provider>
  </GoogleOAuthProvider>,
  document.getElementById('app')
);
